import unblockCancelTripMessagesModule from "./unblockCancelTripMessagesModule"
import unblockCancelTripMessagesDialog from "./unblockCancelTripMessageDialog.html"

unblockCancelTripMessagesModule.service("unblockCancelTripMessageDialog", [
        "$modal",
        function ($modal) {
            return function (message) {
                return $modal.open({
                    template: unblockCancelTripMessagesDialog,
                    size: "xl",
                    backdrop: "static",
                    controller: ["$scope", function ($scope) {
                        $scope.message = message
                        $scope.tripTable = {
                            records: $scope.message.statusByTrip
                        }
                        $scope.erpMessagesTable = {
                            records: $scope.message.erpMessages
                        }
                        $scope.existsUser =  function (){
                            return !!$scope.message.processedByUser
                        }
                    }]
                })

            }
        }
    ])